export default "__VITE_ASSET__ClWypLik__"